import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { locationService } from '../../services/locations';
import { LocationSummary } from '../../types/location';
import { Container, Section, SectionHeader, SectionTitle, SectionSubtitle } from '../ui';

const Links = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: .8rem;
  padding: 0;
  list-style: none;
  a {
    display: block;
    padding: 1rem 1.25rem;
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: ${({ theme }) => theme.borderRadius.md};
    color: ${({ theme }) => theme.colors.foreground};
    line-height: 1.5;
  }
  a:hover, a:focus-visible {
    color: ${({ theme }) => theme.colors.primary};
    border-color: currentColor;
  }
`;

const ExploreLocations: React.FC = () => {
  const [locations, setLocations] = useState<LocationSummary[]>([]);
  useEffect(() => {
    let active = true;
    locationService.listPublished()
      .then((items) => { if (active) setLocations(items.slice(0, 12)); })
      .catch(() => { if (active) setLocations([]); });
    return () => { active = false; };
  }, []);
  if (!locations.length) return null;
  return <Section aria-labelledby="explore-locations-title">
    <Container>
      <SectionHeader>
        <SectionTitle id="explore-locations-title">Explore bairros e condomínios</SectionTitle>
        <SectionSubtitle>Conheça cada local e confira os imóveis disponíveis.</SectionSubtitle>
      </SectionHeader>
      <Links>{locations.map((location) => <li key={location.path}>
        <Link to={location.path}>{location.name}</Link>
      </li>)}</Links>
    </Container>
  </Section>;
};

export default ExploreLocations;
